export default __webpack_public_path__ + "static/media/favicon.c901384f.ico";